<template>
  <div class="results-list">
    <!-- Устанавливаем в key значение index, так как API может возвращать документы с одинаковым id. -->
    <search-result-list-item
      v-for="(item, index) in items"
      :key="index + item.id"
      :item="item"
      :selected="item.id === currentItemId"
      @card-click="onCardClick"
      @favorite-click="onButtonFavoriteClick"
      @watched-click="onButtonWatchedClick"
    />
  </div>
</template>

<script>
import SearchResultListItem from './SearchResultListItem';

import SearchResultSet from '@@/search/mixins/SearchResultSet';

export default {
  components: {
    SearchResultListItem
  },

  mixins: [SearchResultSet],

  props: {
    items: {
      type: Array,
      required: true
    },

    currentItemId: {
      type: String,
      default: null
    }
  },

  methods: {
    onCardClick(documentId) {
      this.$emit('card-click', documentId);
    }
  }
};
</script>
